import React from 'react';

const Disclaimer = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="display-large mb-8">Health & Medical Disclaimer</h1>
            <div className="space-y-6 body-medium">
              <p className="body-large text-[#0C6951]">Effective Date: October 17, 2024

              </p>

              <div className="bg-[#D3FF62] bg-opacity-20 border-l-4 border-[#D3FF62] p-6 rounded">
                <p className="font-semibold text-[#004534]">
                  IMPORTANT: Please read this disclaimer carefully before using FITNOVEXA services.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">1. Not Medical Advice</h2>
                <p>
                  FITNOVEXA provides educational and consulting services related to fitness technology and recreation 
                  management. Our content is not medical advice and should not replace consultation with qualified 
                  healthcare professionals.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">2. Consult Healthcare Professionals</h2>
                <p>
                  Always consult your physician before beginning any fitness program. Never disregard professional 
                  medical advice or delay seeking it because of information from FITNOVEXA.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">3. Physical Activity Risks</h2>
                <p>
                  Physical fitness activities carry inherent risks including injury. Participants should assess 
                  their physical condition and consult healthcare providers before engaging in exercise programs.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">4. Individual Results Vary</h2>
                <p>
                  Results from our services vary based on individual circumstances, effort, and other factors. 
                  We do not guarantee specific outcomes.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">5. Assumption of Risk</h2>
                <p>
                  By using FITNOVEXA services, you acknowledge and assume all risks associated with fitness 
                  activities and technology implementation.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">6. Contact</h2>
                <p>
                  Questions about this disclaimer? Contact us at:<br />
                  Email: info@fitnovexa.com<br />
                  Website: fitnovexa.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default Disclaimer;